import Vue from 'vue';
import '@/utils/lib/array-from-polyfill'; // fix: oppo / vivo 低版本手机浏览器中不支持 Array.from 问题
import waterfall from 'vue-waterfall2'; // 瀑布流布局

import StaticMonitor from '@cy/staticMonitor';
import ChunyuWhiteScreenMonitor from '@cy/chunyuWhiteScreenMonitor';
// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';
import * as Sentry from '@sentry/vue';
import InfiniteScroll from '@/utils/lib/infiniteScroll/index';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/vant-ui/index';
import '@/assets/styles/index.scss';

Vue.use(InfiniteScroll);
Vue.use(waterfall);
if (process.env.NODE_ENV !== 'production') {
  import('vconsole').then(VConsole => {
    // eslint-disable-next-line
    new VConsole.default();
  });
} else {
  // Raven.config(
  //   'https://cfcd84df646d4ba18803156aef095338@sentry.chunyutianxia.com/13',
  //   {
  //     tags: {
  //       vue_mall: 'true',
  //     },
  //     release: `vue_mall@${PackageJson.version}`,
  //   }
  // )
  //   .addPlugin(RavenVue, Vue)
  //   .install();
  Sentry.init({
    Vue,
    dsn: 'https://cfcd84df646d4ba18803156aef095338@sentry.chunyutianxia.com/13',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],

    tracesSampleRate: 0.2,
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost'],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
  const opt = {
    project_name: 'vue-mall', // 项目名称
    desc: '', // 用来替代接口的 description 字段，默认为：前端监控-静态资源加载错误上报
  };

  // eslint-disable-next-line no-new
  new StaticMonitor(opt);
  // window.Sentry = Raven;
  // eslint-disable-next-line no-new
  new ChunyuWhiteScreenMonitor();
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
